module.exports = __webpack_public_path__ + "static/media/salir.3df23955.svg";